export default __webpack_public_path__ + "static/media/job-switching-arrow-right-gray.8c08dad1.svg";